import { Theme } from '@constants';

import { ZoomPreset } from './MapTypes';

// The map width that all our default zoom presets are based on in order to show the intended area.
const standardMapWidth = 1920;

const MapNationalCenter = () => [-98.2, 37.4];

// Get the center [lng, lat] for the specified ZoomPreset.
export const ZoomPresetCenter = (zoomPreset, userLocation) => {
  switch (zoomPreset) {
    case ZoomPreset.local:
    case ZoomPreset.regional:
      return userLocation;

    case ZoomPreset.national:
      return MapNationalCenter();
  }
};

// Get the Mapbox zoom for the specified ZoomPreset.
export const ZoomPresetZoom = (zoomPreset, mapWidth = standardMapWidth) => {
  let adjustedZoom = 1;

  switch (zoomPreset) {
    case ZoomPreset.local:
      adjustedZoom = 9;
      break;
    case ZoomPreset.regional:
      adjustedZoom = 7;
      break;
    case ZoomPreset.national:
      adjustedZoom = 4;
      break;
  }

  // The zoom value at this point is appropriate assuming a 1080p fullscreen map.
  // But our map is drawn at different sizes (which is also dependent on platform), so we
  // need to account for that here.  First, get the scale relative to 1.  Next translate
  // the map zoom from an exponential measurement into a linear dimension by raising
  // it as a power of 2.  Multiply the resulting value by the scale.  Finish by
  // translating from a linear dimension back into an exponential zoom value by
  // taking the natural log.
  const viewSizeScale = mapWidth != null && mapWidth > 100 ? (mapWidth * Theme.pixelRatio()) / standardMapWidth : 1;

  adjustedZoom = Math.log2(Math.pow(2, adjustedZoom) * viewSizeScale);

  return adjustedZoom;
};
